export default __webpack_public_path__ + "static/rich_one-1ea338ad8641bf7b834a033103691fc8.jpeg";